<ngb-carousel
    #payableCarousel
    *ngIf="attachments?.length > 1; else singleAttachment"
    class="carousel-control-container animated fadeIn position-relative">
        <ng-template [id]="attachment.id.toString()" ngbSlide *ngFor="let attachment of attachments; trackBy: trackByAttachmentId">
            <app-payable-attachment-preview
                [attachment]="attachment"
                [containerHeight]="containerHeight">
            </app-payable-attachment-preview>
            <div *ngIf="showCaptions" class="carousel-caption">
                <h5>{{attachment.fileName}}</h5>
            </div>
        </ng-template>
</ngb-carousel>
<ng-template #singleAttachment>
    <app-payable-attachment-preview
        *ngIf="attachments?.length === 1; else noAttachments"
        [attachment]="attachments[0]"
        [containerHeight]="containerHeight">
    </app-payable-attachment-preview>
    <ng-template #noAttachments>
        <div class="animated fadeIn" [style.height]="containerHeight">
            <ph-empty-state center icon="file-text" heading="No attachments">{{ emptyMessage }}</ph-empty-state>
        </div>
    </ng-template>
</ng-template>
